<div>
  <span class="icon" *ngFor="let rateValue of maxItem">
    <i [ngClass]="rateValue <= this.ratedCount ? 'filled' :'' "
       class="fa fa-star"  aria-hidden="true" (click)="toggleRating(subjectId,questionId,rateValue)"></i>
  </span>
</div>
